/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtilizationPerVehicle
 */
export interface UtilizationPerVehicle {
    /**
     * 
     * @type {string}
     * @memberof UtilizationPerVehicle
     */
    vehicleId: string;
    /**
     * 
     * @type {string}
     * @memberof UtilizationPerVehicle
     */
    vehicleSerialNumber: string;
    /**
     * 
     * @type {number}
     * @memberof UtilizationPerVehicle
     */
    driveTimeSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof UtilizationPerVehicle
     */
    driveTimeGoalSeconds: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UtilizationPerVehicle
     */
    chartData: Array<number>;
}

/**
 * Check if a given object implements the UtilizationPerVehicle interface.
 */
export function instanceOfUtilizationPerVehicle(value: object): value is UtilizationPerVehicle {
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('driveTimeSeconds' in value) || value['driveTimeSeconds'] === undefined) return false;
    if (!('driveTimeGoalSeconds' in value) || value['driveTimeGoalSeconds'] === undefined) return false;
    if (!('chartData' in value) || value['chartData'] === undefined) return false;
    return true;
}

export function UtilizationPerVehicleFromJSON(json: any): UtilizationPerVehicle {
    return UtilizationPerVehicleFromJSONTyped(json, false);
}

export function UtilizationPerVehicleFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtilizationPerVehicle {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleId': json['vehicleId'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'driveTimeSeconds': json['driveTimeSeconds'],
        'driveTimeGoalSeconds': json['driveTimeGoalSeconds'],
        'chartData': json['chartData'],
    };
}

export function UtilizationPerVehicleToJSON(json: any): UtilizationPerVehicle {
    return UtilizationPerVehicleToJSONTyped(json, false);
}

export function UtilizationPerVehicleToJSONTyped(value?: UtilizationPerVehicle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleId': value['vehicleId'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'driveTimeSeconds': value['driveTimeSeconds'],
        'driveTimeGoalSeconds': value['driveTimeGoalSeconds'],
        'chartData': value['chartData'],
    };
}

